import React from 'react';
import { NavLink } from 'react-router-dom';
import CONSTANTS from '../../helpers/constants';
import './AccountNav.scss';

const AccountNav = () => {
  return (
        <div className="">
            <ul>
                <NavLink
                    exact={true}
                    to={CONSTANTS.APP_ROUTES.ACCOUNT}
                    className="menu-link"
                    activeClassName="active"
                >
                    <li className="pb-4">Account Information</li>
                </NavLink>
                <NavLink
                    exact={true}
                    to={CONSTANTS.APP_ROUTES.ORDERS}
                    className="menu-link"
                    activeClassName="active"
                >
                    <li className="pb-4">My Orders</li>
                </NavLink>
                {/*<NavLink*/}
                {/*    exact={true}*/}
                {/*    to={CONSTANTS.APP_ROUTES.PAYMENTS}*/}
                {/*    className="menu-link"*/}
                {/*    activeClassName="active"*/}
                {/*>*/}
                {/*    <li className="pb-4">Payments</li>*/}
                {/*</NavLink>*/}
                {/*<NavLink*/}
                {/*    exact={true}*/}
                {/*    to={CONSTANTS.APP_ROUTES.STATEMENTS}*/}
                {/*    className="menu-link"*/}
                {/*    activeClassName="active"*/}
                {/*>*/}
                {/*    <li className="pb-4">Statements</li>*/}
                {/*</NavLink>*/}
                <NavLink
                    exact={true}
                    to={CONSTANTS.APP_ROUTES.UPDATE_ACCOUNT_INFO}
                    className="menu-link"
                    activeClassName="active"
                >
                    <li className="pb-4">Update Account Info</li>
                </NavLink>
            </ul>
        </div>
  );
};

export default AccountNav;
